import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_INTERVAL_MS = 2000;
const MAX_ATTEMPTS = 8; // ~16 seconds

export function usePaymentStatus(sessionId) {
  const [phase, setPhase] = useState("polling"); // polling | paid | expired | error | unpaid
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const attemptsRef = useRef(0);
  const cancelledRef = useRef(false);

  useEffect(() => {
    if (!sessionId) {
      setPhase("error");
      setError("Missing session_id in URL.");
      return undefined;
    }
    cancelledRef.current = false;
    attemptsRef.current = 0;

    const poll = async () => {
      if (cancelledRef.current) return;
      try {
        const { data: d } = await axios.get(`${API}/checkout/status/${sessionId}`);
        if (cancelledRef.current) return;
        setData(d);
        if (d.payment_status === "paid") {
          setPhase("paid");
          return;
        }
        if (d.status === "expired") {
          setPhase("expired");
          return;
        }
        attemptsRef.current += 1;
        if (attemptsRef.current >= MAX_ATTEMPTS) {
          setPhase("unpaid");
          return;
        }
        setTimeout(poll, POLL_INTERVAL_MS);
      } catch (e) {
        if (cancelledRef.current) return;
        setError(e?.response?.data?.detail || e.message);
        setPhase("error");
      }
    };
    poll();

    return () => {
      cancelledRef.current = true;
    };
  }, [sessionId]);

  return { phase, data, error };
}
